<template>
  <v-card class="mb-4"
          id="communication-preferences-card">
    <v-card-title>
      <v-icon left
              color="primary">
        fas fa-fw fa-envelope
      </v-icon>
      {{ isCurrentUser ? 'My Communication Preferences' : 'Communication Preferences' }}
    </v-card-title>
    <v-card-text class="pb-8">

      <p>
        Notify me about:
      </p>

      <div v-if="team.send_failed_email_notifications && canSendEmail"
           class="d-flex align-center mb-4">
        <v-switch v-model="form.send_failed_email_notifications"
                  label="Email delivery issues and delays"
                  hide-details
                  class="my-0 py-0 mr-1">
        </v-switch>
        <ToolTip color="primary"
                 icon-color="success">
          Get notified when emails are temporarily delayed due to recipient server issues or sending limits. Mobile Locker automatically retries delivery.
        </ToolTip>
      </div>

      <!-- https://help.mailgun.com/hc/en-us/articles/203661564-What-do-each-of-the-event-filter-types-mean- -->

      <div v-if="canSendEmail"
           class="d-flex align-center mb-4">
        <v-switch v-model="form.send_permanently_failed_email_notifications"
                  label="Permanent email delivery failures"
                  hide-details
                  class="my-0 py-0 mr-1">
        </v-switch>
        <ToolTip color="primary"
                 icon-color="success">
          Get alerted when emails cannot be delivered and are permanently dropped due to invalid addresses or repeated delivery failures.
        </ToolTip>
      </div>

      <div class="d-flex align-center mb-4">
        <v-switch v-model="form.send_unsubscribe_notifications"
                  label="Email unsubscribes and opt-outs"
                  hide-details
                  class="my-0 py-0 mr-1">
        </v-switch>
        <ToolTip color="primary"
                 icon-color="success">
          Receive notifications when recipients unsubscribe from your emails or opt out of communications.
        </ToolTip>
      </div>

      <div v-if="isAdmin"
           class="d-flex align-center mb-4">
        <v-switch v-model="form.send_expiration_notifications"
                  label="Monthly presentation expiration reports and alerts"
                  hide-details
                  class="my-0 py-0 mr-1">
        </v-switch>
        <ToolTip color="primary"
                 icon-color="success">
          Receive a monthly report on the 1<sup>st</sup> showing all presentations expiring that month, plus individual alerts when each presentation actually expires.
        </ToolTip>
      </div>

      <div v-if="isAdmin"
           class="d-flex align-center mb-4">
        <v-switch v-model="form.send_upload_notifications"
                  label="My presentation upload status (success/failure)"
                  hide-details
                  class="my-0 py-0 mr-1">
        </v-switch>
        <ToolTip color="primary"
                 icon-color="success">
          Get notified when presentations you upload are successfully processed or encounter errors during upload.
        </ToolTip>
      </div>

      <div v-if="team.veeva_vault_enabled && isAdmin"
           class="d-flex align-center mb-4">
        <v-switch v-model="form.send_presentation_imported_notifications"
                  label="All Veeva Vault presentation imports (by any user)"
                  hide-details
                  class="my-0 py-0 mr-1">
        </v-switch>
        <ToolTip color="primary"
                 icon-color="success">
          Receive notifications whenever any user in your organization imports presentations from Veeva Vault.
        </ToolTip>
      </div>

      <div v-if="team.uses_pepper_flow && isAdmin"
           class="d-flex align-center mb-4">
        <v-switch v-model="form.send_presentation_imported_notifications"
                  label="All PepperFlow presentation imports (by any user)"
                  hide-details
                  class="my-0 py-0 mr-1">
        </v-switch>
        <ToolTip color="primary"
                 icon-color="success">
          Receive notifications whenever any user in your organization imports presentations from PepperFlow.
        </ToolTip>
      </div>

    </v-card-text>
  </v-card>
</template>
<script>
import {mapGetters} from 'vuex';
import ToolTip from '../../../components/ToolTip.vue';

export default {
  components: {ToolTip},
  props: {
    form: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'activeUsers',
      'canSendEmail',
      'countries',
      'currentUser',
      'groups',
      'isAdmin',
      'isMember',
      'locales',
      'team',
      'teamRoles',
      'timezones',
    ]),
    isCurrentUser() {
      return this.currentUser.id === this.user.id;
    },
  },
}
</script>
